'use strict';

/**
 * @param {Object} object
 * @param {string[]} keys
 * @returns {Object}
 */
export default function pick(object, keys) {
    const result = {};
    keys.forEach(function (key) {
        if (object != null && Object.hasOwn(object, key)) {
            result[key] = object[key];
        }
    });
    return result;
}
